import { render } from "./ShareSns.vue?vue&type=template&id=358e4396&scoped=true&ts=true"
import script from "./ShareSns.vue?vue&type=script&lang=ts"
export * from "./ShareSns.vue?vue&type=script&lang=ts"

import "./ShareSns.vue?vue&type=style&index=0&id=358e4396&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-358e4396"]])

export default __exports__